export class NotSablonEntity {
    id!: number;
    isim!: string;
    not!: string;
}